import {
  breakpointSizes,
  getBreakpointDown,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import { avatar_colorFallbackText } from 'ext-ui/style/colors'
import React from 'react'
import { getAvatarFallbackColor } from 'src/components/TextAvatar/avatarColor'
import { AvatarSizes } from 'src/enums'
import { UserAvatarColor } from 'src/models/user.models'
import { css } from 'styled-components'

interface TextAvatarProps {
  className?: string
  text?: string
  id?: string
  defaultIcon?: React.ReactElement
  avatarColor?: UserAvatarColor | null
  size: AvatarSizes
}

const TextAvatar: React.FC<TextAvatarProps> = (props): React.ReactElement => {
  return (
    <div
      className={props.className}
      // TODO: remove instances of Small24 and replace Small with Small24 after datagrid updates released
      css={css`
        padding-left: 1px;

        ${props.size === AvatarSizes.Small &&
        css`
          width: 22px;
          height: 22px;
        `}
        ${props.size === AvatarSizes.Small24 &&
        css`
          width: 24px;
          height: 24px;
        `}

        ${props.size === AvatarSizes.Medium &&
        css`
          width: 32px;
          height: 32px;
        `}

        ${props.size === AvatarSizes.MediumLarge &&
        css`
          width: 36px;
          height: 36px;
        `}

        ${props.size === AvatarSizes.Large &&
        css`
          width: 40px;
          height: 40px;
        `}

        ${props.size === AvatarSizes.Huge &&
        css`
          width: 60px;
          height: 60px;

          ${getBreakpointDown(breakpointSizes.XSM)(css`
            width: 50px;
            height: 50px;
          `)}
        `}
      `}
    >
      <div
        css={css`
          border-radius: 50%;
          background-color: ${getAvatarFallbackColor(props.avatarColor) ??
          styleConstants.colors.white};
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.15);

          ${props.size === AvatarSizes.Small &&
          css`
            width: 22px;
            height: 22px;
          `}

          ${props.size === AvatarSizes.Small24 &&
          css`
            width: 24px;
            height: 24px;
          `}

        ${props.size === AvatarSizes.Medium &&
          css`
            width: 32px;
            height: 32px;
          `}

        ${props.size === AvatarSizes.MediumLarge &&
          css`
            width: 36px;
            height: 36px;
          `}

        ${props.size === AvatarSizes.Large &&
          css`
            width: 40px;
            height: 40px;
          `}

        ${props.size === AvatarSizes.Huge &&
          css`
            width: 60px;
            height: 60px;

            ${getBreakpointDown(breakpointSizes.XSM)(css`
              width: 50px;
              height: 50px;
            `)}
          `}

        ${props.size === AvatarSizes.ExtraHuge &&
          css`
            width: 100px;
            height: 100px;
          `}

        ${props.size === AvatarSizes.ExtraExtraHuge &&
          css`
            width: 140px;
            height: 140px;
          `}
        `}
      >
        {props.text !== undefined && (
          <span
            id={props.id ? props.id : 'initials'}
            css={css`
              color: ${props.avatarColor === undefined ||
              props.avatarColor === null
                ? themeConstants.colors.highlight
                : avatar_colorFallbackText};
              text-align: center;

              ${props.size === AvatarSizes.Small &&
              css`
                font-size: 10px;
                line-height: 10px;
              `}

              ${props.size === AvatarSizes.Small24 &&
              css`
                font-size: 9px;
                line-height: 9px;
              `}

              ${props.size === AvatarSizes.Medium &&
              css`
                font-size: 16px;
                line-height: 16px;
              `}

              ${props.size === AvatarSizes.MediumLarge &&
              css`
                font-size: 18px;
                line-height: 18px;
              `}

              ${props.size === AvatarSizes.Large &&
              css`
                width: 22px;
                height: 22px;
              `}

              ${props.size === AvatarSizes.Huge &&
              css`
                font-size: 24px;
                line-height: 24px;
              `}

              ${props.size === AvatarSizes.ExtraHuge &&
              css`
                font-size: 36px;
                line-height: 36px;
              `}

              ${props.size === AvatarSizes.ExtraExtraHuge &&
              css`
                font-size: 40px;
                line-height: 40px;
              `}
            `}
          >
            {props.text}
          </span>
        )}
        {props.text === undefined && props.defaultIcon}
      </div>
    </div>
  )
}

export default TextAvatar
